import { get, put } from '../Services/http';
import { catchError } from './Error.action';
import {
  CART_LOAD_ERROR,
  CART_RECEIVE,
  CART_SHOW_MINI_CART,
  CART_ADD_TO_CART_ANIMATION,
} from '../constants';
import { toast } from 'react-toastify';
import { triggerToast } from '../Services/Toast.service';
import { translate } from '../Services/translation';
import { dataLayerRemoveFromCart } from '../Services/Gtm.service';

let cartAbortController;

export const load = () => (dispatch, getState) => {
  cartAbortController?.abort();
  cartAbortController = new AbortController();
  return get('/api/cart', cartAbortController)
    .then((response) => response.json())
    .then((cart) => {
      dispatch(receive(cart));
    })
    .catch((ex) => {
      if (ex.name == 'AbortError') return;

      return dispatch(catchError(ex, (error) => loadError(error)));
    });
};

export const loadError = (error) => (dispatch) => {
  triggerToast({
    title: translate('general.error'),
    text: error?.error ?? translate('general.error'),
    type: 'error',
    autoClose: false,
  });

  return dispatch({
    type: CART_LOAD_ERROR,
    payload: {
      error,
    },
  });
};

export const receive = (cart) => (dispatch, getState) => {
  if (getState().cart.quantity != cart.quantity) {
    dispatch(triggerAddToCartAnimation());
  }

  return dispatch({
    type: CART_RECEIVE,
    payload: cart,
  });
};

export const toggle = () => (dispatch, getState) => {
  dispatch(show(!getState().cart.showMiniCart));
};

export const setShowMiniCart = (showMiniCart) => ({
  type: CART_SHOW_MINI_CART,
  payload: {
    showMiniCart,
  },
});

export const update =
  (rowSystemId, quantity, note = null, abortController = null) =>
  (dispatch, getState) => {
    const existingRow = getState().cart.orderRows.find(
      (r) => r.rowSystemId == rowSystemId
    );
    var articleNumber = existingRow?.articleNumber;

    return put(
      `/api/cart/update`,
      { rowSystemId, quantity, note, articleNumber },
      abortController
    )
      .then((response) => response.json())
      .then((cart) => dispatch(receive(cart)))
      .then(
        () => existingRow && quantity <= 0 && onRemoveFromCart(existingRow)
      )
      .catch((ex) =>
        dispatch(catchError(ex, (error) => loadError(error)))
      );
  };

let addToCartAnimationTimeoutId;
export const triggerAddToCartAnimation = () => (dispatch, getState) => {
  const addToCartAnimating = getState().cart.addToCartAnimating;
  if (!addToCartAnimating) {
    if (addToCartAnimationTimeoutId) {
      clearTimeout(addToCartAnimationTimeoutId);
    }

    dispatch(setAddToCartAnimating(true));
    addToCartAnimationTimeoutId = setTimeout(
      () => dispatch(setAddToCartAnimating(false)),
      500
    );
  }
};

const setAddToCartAnimating = (addToCartAnimating) => ({
  type: CART_ADD_TO_CART_ANIMATION,
  payload: {
    addToCartAnimating,
  },
});

const onRemoveFromCart = (orderRow) => {
  dataLayerRemoveFromCart([orderRow.gtmEcommerceItem]);
};
